
export default () => {

    const modal = document.querySelector('.video-modal')
    const cards = Array.from(document.querySelectorAll('.video-card'))

    if(!modal || !cards) return

    modal.querySelector('.gg-close').addEventListener('click', () => {
        document.body.classList.remove('video-modal-active')
        modal.querySelector('iframe').setAttribute('src', 'http://')
    })

    cards.forEach(card => {
        card.addEventListener('click', () => {
            const url = card.getAttribute('for')
            modal.querySelector('iframe').setAttribute('src', url)
            document.body.classList.add('video-modal-active')
        })
    })
}
